import store from '@/store'
import axios from 'axios'
import User from '@/connection/user'

export default {

  async sendRating(order_id, rating, improvement_tag_list, comment, on_schedule, app_score) {

    let sessionToken = await User.getSessionToken('session_token')
    if (sessionToken) {
      let header = {'Authorization': sessionToken}
      try {
        let result = await axios.post(store.getters.getRatingApi + '/ratings', {
          company_id: store.getters.getChoiceCompanyId,
          order_id: order_id,
          rating: rating,
          improvement_tag_list: improvement_tag_list,
          comment: comment,
          on_schedule: on_schedule,
          app_score: app_score,

        }, {headers: header})
        if (result.data) {
          return result.data
        } else {
          console.log(' error response', result)
          return {error: true, code: 400, msg: 'Erro ao salvar avalição.'}
        }
      } catch (e) {
        let error = {e}
        console.log(error)
        return {error: true, code: 500, msg: 'Erro ao salvar avalição'}
      }
    } else {
      return {error: true, code: 400, msg: 'Usuário sem login'}
    }
  },

  async getAllRatingByUserId() {
    try {
      let userId = store.state.user.id
      let response = await axios.get(store.getters.getRatingApi + '/ratings/users/' + userId)
      if (response.data) {
        store.state.ratings = response.data
        return response.data
      } else {
        return null
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error: true, msg: error.e.msg}
    }
  }
}
